// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Works from './pages/Works';
import Lab from './pages/Lab';
import Header from './components/Header';
import WorkDetail from './pages/WorkDetail';
import LabDetail from './pages/LabDetail';
import RouteGrid from './components/forming/RouteGrid.jsx';

import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const location = useLocation();
  const pageVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const pageTransition = {
    duration: 0.8,
    ease: "easeInOut",
  };
  const isHome = location.pathname === "/";
  
  return (
    <AnimatePresence mode="wait">
      {/* <Router> */}
        <div className="App">
          <header>
            <Header />
          </header>
          <div className="main-component">
            <div className={isHome ? "home-wrapper" : "content"}>
              <Routes location={location} key={location.pathname}>
                <Route path="/" element={
                   <motion.div
                     initial="initial"
                     animate="animate"
                     exit="exit"
                     variants={pageVariants}
                     transition={pageTransition}
                   >
                   <Home />
                   </motion.div>
                 }
                />
                <Route path="/forming" element={<RouteGrid/>} />
                <Route path="/about" element={
                    <motion.div
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                    <About />
                    </motion.div>
                  }
                />
                <Route path="/works" element={
                   <motion.div
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                    <Works />
                    </motion.div>
                  }
                />
                <Route path="/works/:slug" element={
                   <motion.div
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                    <WorkDetail />
                    </motion.div>
                  }
                />
                <Route path="/lab" element={
                   <motion.div
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                    <Lab />
                    </motion.div>
                  }
                />
                <Route path="/labworks/:slug" element={
                   <motion.div
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                    <LabDetail />
                    </motion.div>
                  }
                />
              </Routes>
            </div> 
            <div className="footer">
              <p>@2026 Natsumi H.</p>
            </div>       
          </div>

      </div> 
      {/* </Router> */}
    </AnimatePresence>
  );
}

export default App;
